import { render, staticRenderFns } from "./ProgressCitoResults.vue?vue&type=template&id=961256c8&scoped=true&"
import script from "@/views/Users/Student/Progress/ProgressCitoResults.ts?vue&type=script&lang=ts&"
export * from "@/views/Users/Student/Progress/ProgressCitoResults.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Users/Student/Progress/progress-cito-results.scss?vue&type=style&index=0&id=961256c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961256c8",
  null
  
)

export default component.exports